// import { useCallback } from "react";
// import { useState } from "react";
import ReactGridLayout, { ResponsiveProps, WidthProviderProps } from "react-grid-layout";

Storage.prototype.setObject = function (key: string, value: any) {
    this.setItem(key, JSON.stringify(value));
};

Storage.prototype.getObject = function (key: string) {
    var value = this.getItem(key);
    return value && JSON.parse(value);
};

// let INIT_LAYOUTS = localStorage.getObject("dashboard-layouts");

// if (!INIT_LAYOUTS)
let INIT_LAYOUTS: ReactGridLayout.Layouts = {
    lg: [
        { i: "rccp", x: 0, y: 0, w: 6, h: 8, minW: 6, maxW: 12, maxH: 8 },
        { i: "prep_rccp", x: 0, y: 1, w: 6, h: 8, minW: 6, maxW: 12, maxH: 8 },
        { i: "unmet", x: 6, y: 0, w: 6, h: 8, minW: 6, maxW: 12, maxH: 8 },
        { i: "maximization", x: 0, y: 2, w: 12, h: 2, minW: 6, maxW: 12, maxH: 6 },
        { i: "demand-constraints", x: 0, y: 3, w: 12, h: 2, minW: 6, maxW: 12, maxH: 6 },
        { i: "capacity-constraints", x: 0, y: 4, w: 12, h: 2, minW: 6, maxW: 12, maxH: 6 },
        { i: "prep-capacity-constraints", x: 0, y: 5, w: 12, h: 2, minW: 6, maxW: 12, maxH: 6 },
        { i: "solution", x: 0, y: 6, w: 12, h: 2, minW: 6, maxW: 12, maxH: 6 },
    ],

    md: [
        { i: "rccp", x: 0, y: 0, w: 6, h: 8, minW: 6, maxW: 12, maxH: 8 },
        { i: "prep_rccp", x: 0, y: 1, w: 6, h: 8, minW: 6, maxW: 12, maxH: 8 },
        { i: "unmet", x: 6, y: 0, w: 6, h: 8, minW: 6, maxW: 12, maxH: 8 },
        { i: "maximization", x: 0, y: 2, w: 12, h: 2, minW: 6, maxW: 12, maxH: 6 },
        { i: "demand-constraints", x: 0, y: 3, w: 12, h: 2, minW: 6, maxW: 12, maxH: 6 },
        { i: "capacity-constraints", x: 0, y: 4, w: 12, h: 2, minW: 6, maxW: 12, maxH: 6 },
        { i: "prep-capacity-constraints", x: 0, y: 5, w: 12, h: 2, minW: 6, maxW: 12, maxH: 6 },
        { i: "solution", x: 0, y: 6, w: 12, h: 2, minW: 6, maxW: 12, maxH: 6 },
    ],
    sm: [
        { i: "rccp", x: 0, y: 0, w: 12, h: 8, minW: 6, maxW: 12, maxH: 8 },
        { i: "prep_rccp", x: 0, y: 1, w: 12, h: 8, minW: 6, maxW: 12, maxH: 8 },
        { i: "unmet", x: 6, y: 0, w: 12, h: 8, minW: 6, maxW: 12, maxH: 8 },
        { i: "maximization", x: 0, y: 2, w: 12, h: 2, minW: 6, maxW: 12, maxH: 6 },
        { i: "demand-constraints", x: 0, y: 3, w: 12, h: 2, minW: 6, maxW: 12, maxH: 6 },
        { i: "capacity-constraints", x: 0, y: 4, w: 12, h: 2, minW: 6, maxW: 12, maxH: 6 },
        { i: "prep-capacity-constraints", x: 0, y: 5, w: 12, h: 2, minW: 6, maxW: 12, maxH: 6 },
        { i: "solution", x: 0, y: 6, w: 12, h: 2, minW: 6, maxW: 12, maxH: 6 },
    ],
    xs: [
        { i: "rccp", x: 0, y: 0, w: 12, h: 8, minW: 6, maxW: 12, maxH: 8 },
        { i: "prep_rccp", x: 0, y: 1, w: 12, h: 8, minW: 6, maxW: 12, maxH: 8 },
        { i: "unmet", x: 6, y: 0, w: 12, h: 8, minW: 6, maxW: 12, maxH: 8 },
        { i: "maximization", x: 0, y: 2, w: 12, h: 2, minW: 6, maxW: 12, maxH: 6 },
        { i: "demand-constraints", x: 0, y: 3, w: 12, h: 2, minW: 6, maxW: 12, maxH: 6 },
        { i: "capacity-constraints", x: 0, y: 4, w: 12, h: 2, minW: 6, maxW: 12, maxH: 6 },
        { i: "prep-capacity-constraints", x: 0, y: 5, w: 12, h: 2, minW: 6, maxW: 12, maxH: 6 },
        { i: "solution", x: 0, y: 6, w: 12, h: 2, minW: 6, maxW: 12, maxH: 6 },
    ],
};

const useCombinationsLayout = () => {
    // const [breakpoint, setBreakPoint] = useState("lg");
    // const [layouts, setLayouts] = useState({ ...INIT_LAYOUTS });

    // const layoutChangeHandler = useCallback(
    //     (newLayout: ReactGridLayout.Layout[], allLayouts: ReactGridLayout.Layouts) => {
    //         console.log(allLayouts);
    //         // setLayouts(layouts);
    //         // localStorage.setObject("dashboard-layouts", allLayouts);
    //     },
    //     []
    // );

    const gridLayoutProps: ResponsiveProps & WidthProviderProps = {
        className: "layout",
        rowHeight: 40,
        margin: [10, 10],
        breakpoints: { lg: 1280, md: 960, sm: 720, xs: 480 },
        cols: { lg: 12, md: 12, sm: 12, xs: 12 },
        // initialLayout: INIT_LAYOUTS[breakpoint],
        layouts: INIT_LAYOUTS,
        // onLayoutChange: layoutChangeHandler,
        compactType: "vertical",
        onBreakpointChange: (b) => {
            // console.log(b);
            // setBreakPoint(b);
        },
    };

    return { gridLayoutProps };
};

export default useCombinationsLayout;
